import { faNoteSticky, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { isAddedTimeSheet, isNonProductiveTimeSheet } from "../helpers";
import { useUser } from "../../../../../utils/hooks/user";
import moment from "moment-timezone";

export const useActionsColumn = ({ edit, remove }) => {
    const { t } = useTranslation();
    const user = useUser();

    return useMemo(() => ({
        Header: t("actions"),
        id: "actions",
        hideable: false,
        Cell: ({ row, cell, data }) => {
            const { original } = row;
            const disabled = cell.disabled;
            const isAdded = isAddedTimeSheet(original);
            if (isAdded && !original.isTouched) {
                return null;
            }
            const timesheets = data?.filter((item) => moment(item.date).format("YYYY-MM-DD") === moment(original.date).format("YYYY-MM-DD") && !item?.isAdded);
            const nonProductiveTimeSheets = timesheets.filter((timesheet) => isNonProductiveTimeSheet(timesheet));

            return (
                <div className="d-flex justify-content-end align-items-center gap-x-3">
                    {(edit && !disabled && !original.isNonProductiveTime) && (
                        <span
                            className={classNames(
                                "cursor-pointer", 
                                original?.note ? "text-primary" : "text-muted",
                                original?.locked && "text-muted"
                            )}
                            onClick={() => edit(original)}
                        >
                            <FontAwesomeIcon icon={faNoteSticky} size="lg" />
                        </span>
                    )}

                    {(!original?.locked && (
                        (!isAdded && remove && !original.isNonProductiveTime) ||
                        (original.isNonProductiveTime && !!user?.roles?.find((role) => role?.id === "ROLE_ADMIN") && nonProductiveTimeSheets.length === timesheets.length)
                    )) && (
                            <span
                                className="cursor-pointer text-red"
                                onClick={() => remove({ data: original.id })}
                            >
                                <FontAwesomeIcon icon={faTrash} size="lg" />
                            </span>
                        )}
                </div>
            );
        },
    }), [t, edit, remove, user?.roles]);
};
